import { FC } from 'react';

import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from '../../../shared/ui/TableV2';

import { Page } from '@distribute/shared/types';

import { WorkspacePageCard } from './WorkspacePageCard';
import { WorkspacePageRow } from './WorkspacePageRow';

type Props = {
  onDeletePage: (id: string) => void;
  onMoveToFolder: (id: string) => void;
  onSharePage: (id: string) => void;
  pages: Page[];
};

export const PagesGrid: FC<Props> = ({
  pages,
  onDeletePage,
  onMoveToFolder,
  onSharePage,
}) => {
  return (
    <div className="sm:-mx-1 grid gap-5 sm:grid-cols-[repeat(auto-fill,minmax(320px,1fr))] grid-cols-[repeat(auto-fill,minmax(340px,1fr))]">
      {pages.map((page) => (
        <WorkspacePageCard
          key={page.id}
          page={page}
          onDelete={onDeletePage}
          onMoveToFolder={onMoveToFolder}
          onSharePage={onSharePage}
        />
      ))}
    </div>
  );
};

export const PagesList: FC<Props> = ({
  pages,
  onDeletePage,
  onMoveToFolder,
  onSharePage,
}) => {
  return (
    <div className="sm:-mx-3 overflow-x-auto -mx-2 px-2 pb-2 -mb-2">
      <Table className="table-fixed">
        <TableHeader>
          <TableHeaderCell className="sm:w-66 w-135">Name</TableHeaderCell>
          <TableHeaderCell className="w-34">Status</TableHeaderCell>
          <TableHeaderCell className="w-34">Created</TableHeaderCell>
          <TableHeaderCell className="w-34">Views</TableHeaderCell>
          <TableHeaderCell className="w-14">Owner</TableHeaderCell>
          <TableHeaderCell className="w-15" />
        </TableHeader>
        {pages.map((page) => (
          <>
            <TableRow key={page.id + 'gap'} className="h-2" />
            <WorkspacePageRow
              key={page.id}
              page={page}
              onDelete={onDeletePage}
              onMoveToFolder={onMoveToFolder}
              onSharePage={onSharePage}
            />
          </>
        ))}
      </Table>
    </div>
  );
};
